//import services from "./services";

const initialState = {
  loading_listProducts: true,
  listProducts: [],
  productListLen: 0,
  productListFilteredLen: 0,
  listProductsFiltered: [],
  categoryFilterSelected: "",
  resourcesLocker: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case "getProductListSucces":
      return {
        ...state,
        listProducts: action.payload,
        listProductsFiltered: action.payload,
      };
    case "updateProductListSucces":
      return {
        ...state,
        listProducts: action.payload,
        
      };
    case "setFilterListSucces":
      return { ...state, listProductsFiltered: action.payload };
    case "clearFilterListSucces":
        return { ...state, listProductsFiltered: action.payload };
    default:
      throw new Error(`no such action type ${action.type}`);
  }
};

const asyncChatActionHandlers = {
  setProductList: ({ dispatch }) => async (action) => {
    try {
      dispatch({
        type: "getProductListSucces",
        payload: action.payload,
      });
    } catch (error) {
      console.log("error ", error);
    }
  },
  setFilterListBySearch: ({ dispatch }) => async (action) => {
    try {
      
      const filterResult = action.listProducts.filter(
        (resource) =>
          (resource.name &&
            resource.name
              .toLowerCase()
              .search(action.searchField.toLowerCase()) !== -1) ||
          (resource.description &&
            resource.description
              .toLowerCase()
              .search(action.searchField.toLowerCase()) !== -1)
      );
      dispatch({
        type: "setFilterListSucces",
        payload: filterResult,
      });
    } catch (error) {
      console.log("error ", error);
    }
  },
  setFilterListByCategory: ({ dispatch }) => async (action) => {
    try {
        const filterResult = action.listProducts.filter(
            (resource) =>
              resource.categories && resource.categories.includes(action.categoryId)
          );
      
      dispatch({
        type: "setFilterListSucces",
        payload: filterResult,
      });
    } catch (error) {
      console.log("error ", error);
    }
  },
  orderFilterName: ({ dispatch }) => async (action) => {
    try {
        const newR = action.listProductsFiltered
        .slice() // Slice creates a coppy and helps react recognize that there's a change on this array.
        .sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
    
    dispatch({
        type: "setFilterListSucces",
        payload: newR,
      });
    } catch (error) {
      console.log("error ", error);
    }
  },
  orderFilterPrice: ({ dispatch }) => async (action) => {
    try {
        const newR = action.listProductsFiltered
        .slice() // Slice creates a coppy and helps react recognize that there's a change on this array.
        .sort((a, b) => Number(a.price_from) - Number(b.price_from));
    
    dispatch({
        type: "setFilterListSucces",
        payload: newR,
      });
    } catch (error) {
      console.log("error ", error);
    }
  },
  clearFilterList: ({ dispatch }) => async (action) => {
    console.log("action", action.payload);
    try {
      dispatch({
        type: "clearFilterListSucces",payload: action.payload,
      });
    } catch (error) {
      console.log("error ", error);
    }
  },
  setOnLocker: ({ dispatch }) => async (action) => {
    //console.log("action", action.listProductsFiltered);
    const list = [...action.listProducts];
    const indexList = action.listProducts.findIndex(obj => obj.id === action.resource_id)
    list[indexList]['onLocker']?list[indexList]['onLocker']=action.onLocker:list[indexList]={...list[indexList],onLocker:action.onLocker}

    const filteredList = [...action.listProductsFiltered];
    const indexListFiltered = action.listProductsFiltered.findIndex(obj => obj.id === action.resource_id)
    filteredList[indexListFiltered]['onLocker']?filteredList[indexListFiltered]=action.onLocker:filteredList[indexListFiltered]={...filteredList[indexListFiltered],onLocker:action.onLocker}

    try {
      dispatch({
        type: "setFilterListSucces",payload: filteredList,
      });
      dispatch({
        type: "updateProductListSucces",payload: list,
      });
      //console.log("action2", action.listProductsFiltered);
    } catch (error) {
      console.log("error ", error);
    }
  },
};

export { initialState, reducer, asyncChatActionHandlers };
